export const SORT_DESC = 'desc';
export const SORT_ASC = 'asc';

/**
 * Transforms a mapping `{ [column]: SORT_[ASC|DESC] }` to a list of
 * `column` preceded by a `-` if `column` value in object is `SORT_DESC`
 *
 * e.g.: `{ column: SORT_DESC, other: SORT_ASC, ...  }`: ['-column', 'other'];
 *
 * @param {Object.<string, SORT_ASC|SORT_DESC>} sorting - mapping
 * @returns {Array<String>} column names, preceded with `-` if SORT_DESC
 */
export default sorting => Object.entries(sorting).map(
  ([field, dir]) => dir === SORT_DESC
    ? `-${field}`
    : field
);
